export default "__VITE_ASSET__40fbee21__"